import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatListOption } from '@angular/material/list';


interface PageSelectDialogData {
    pages: { name: string, displayName: string }[];
}

@Component({
    selector: 'page-select-dialog',
    template: `
        <div mat-dialog-content>
          <p>Export to PDF</p>
                    <mat-selection-list #pageList (selectionChange)="onPagesChange(pageList.selectedOptions.selected)"  [style.overflow]="'auto'" [style.height.px]="'200'" >

                        <mat-list-option *ngFor="let page of data.pages" [value]="page.name">
                            {{page.displayName}}
                        </mat-list-option>
                    </mat-selection-list>
        </div>

        <div mat-dialog-actions>
          <button mat-button (click)="onCancelClick()">Cancel</button>
          <button mat-button [mat-dialog-close]="selectedPages" [disabled]="selectedPages.length== 0" >Ok</button>
        </div>
    `,
    styles: [
        `
        div[mat-dialog-content] {
          padding: 20px;
        }
        `
    ]
})
export class PageSelectDialogComponent {

    public static $name: string = 'PageSelectDialog';
    public pageName: string = '';
    public selectedPages: string[] = [];


    constructor(
        private dialogRef: MatDialogRef<PageSelectDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: PageSelectDialogData
    ) {
    }


    public onCancelClick() {
        this.dialogRef.close();
    }

    public onPagesChange(options: MatListOption[]) {
        this.selectedPages = options.map(o => o.value);
        
    }

}
